/**
 * Identidad de quien hizo el sistema.
 *
 * POR QUE VIVE AQUI Y NO EN `features/demo/`
 * ------------------------------------------
 * Nacio ahi, junto al logotipo, porque el recorrido de demostracion era lo unico
 * que la usaba. Se muda por la MISMA razon que ya movio el glifo de WhatsApp a
 * `components/` —y esa nota sigue escrita en `features/demo/aziru.tsx`—: en
 * cuanto una pantalla del negocio la necesita, dejarla en el modulo de la
 * demostracion ata el mostrador a algo que un dia se puede borrar.
 *
 * Quien la necesita ahora es la pantalla de Sucursales: al llegar al limite del
 * plan contratado hay que decir a quien contactar, y ese dato no puede estar
 * escrito dos veces —ya lo estuvo: el ticket impreso trae el numero a mano—.
 *
 * Aqui va SOLO el dato. El logotipo dibujado se queda en `features/demo/`
 * mientras nadie mas lo pinte.
 */
export const AZIRU = {
  name: 'Aziru',
  tagline: 'Sistemas inteligentes a la medida',
  phoneDisplay: '55 3188 7844',
  whatsappUrl: 'https://wa.me/525531887844',
} as const;
